export * from './About';
export * from './Blog';
export * from './Contact';
export * from './Projects';
export * from './Services';
export * from './SinglePost';
export * from './JoinUs';



// WEBPACK FOOTER //
// ./src/pages/index.js